import React from "react";
import { Box, BoxProps } from "@edricphan2022/uikit";
import styled from "styled-components";

const Container: React.FC<BoxProps> = ({ children, ...props }) => (
  <ContainerWapper {...props}>
    {children}
  </ContainerWapper>
);
//

const ContainerWapper = styled(Box)`
  margin: auto;
  width: 100%;
  padding: 0px 5.4vw;
  max-width: 1920px;
  @media only screen and (max-width: 1440px){
    padding: 0px 36px ;
  }
  @media only screen and (max-width: 820px){
    padding: 0px 12px ;
  }
`

export default Container;
